<template>
    <v-dialog v-model="shows" :width="width" content-class="v-dialog--default">
        <template #activator="{attrs,on}">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card class="v-card--default">
            <v-card-title>
                {{ title }}
                <v-spacer />
                <v-btn icon @click="shows = false" class="v-dialog--default__close">
                    <i class="icon icon-close-dark"></i>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" :lg="showsActions ? '8' : ''">
                        <slot />
                    </v-col>
                    <v-col cols="12" lg="4" v-if="showsActions">
                        <slot name="actions" />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        title: { type: String, default: "" },
        width: { type: String, default: "670" },
        showsActions: { type: Boolean, default: false },
    },
    data: () => ({
        shows: false,
    }),
    watch: {
        shows() {
            if (this.shows) this.$emit("open");
            if (!this.shows) this.$emit("close");
        },
    },
};
</script>

<style></style>
